import React from 'react';
import classnames from 'classnames';

import styles from './NoDataMessage.module.scss';

interface NoDataMessageProps {
  className?: string;
  message: string;
}

// データ未登録時の表示
export const NoDataMessage: React.FC<NoDataMessageProps> = ({ message, className }) => {
  return (
    <div className={classnames(styles.noData, className)}>
      <p>{message}</p>
    </div>
  );
};
